export default "__VITE_ASSET__2dfc4866__"